const IncomingLineData = {
  /* 测一测 */
  1: {
    background:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8071c6cddd6650fddc08a43f4565d21d.webp',
    btns: [
      {
        width: 293,
        height: 64,
        left: 41,
        top: 541,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F885b7ae46898ef64296cde7726a29d22.png'
      },
      {
        width: 293,
        height: 64,
        left: 41,
        top: 463,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F93ee7695ab35104acdcbdd46f8f9781a.png'
      }
    ]
  },
  /* 营养师置顶 */
  2: {
    background:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f79f9c41545407034c2438155c9caf4a.webp',
    btns: [
      {
        width: 293,
        height: 64,
        left: 41,
        top: 562,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F18b29ba55c27b71f8565f83a96dcb27e.png'
      },
      {
        width: 293,
        height: 64,
        left: 41,
        top: 484,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F32e00a47ee1ee47ab8dda2d99a249e0d.png'
      }
    ]
  },
  /* 彭彭 */
  3: {
    background:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bda2ece15689e24ab05f94dc08c8326b.webp',
    btns: [
      {
        width: 293,
        height: 64,
        left: 41,
        top: 562,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F4d80b794a5e05fbee95f0fa9a9f5ef90.png'
      },
      {
        width: 293,
        height: 64,
        left: 41,
        top: 484,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252Fad9e2297306156b5db4881637f6f20f7.png'
      }
    ]
  },
  /* 王莹 */
  4: {
    background:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9495364e0b76e87444d1e66083407dcf.webp',
    btns: [
      {
        width: 293,
        height: 64,
        left: 41,
        top: 562,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F95ea6d72e52dac7a899565390fa78786.png'
      },
      {
        width: 293,
        height: 64,
        left: 41,
        top: 484,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252Fa29f162cc2a4b6781bb747c24e5e492d.png'
      }
    ]
  },
  /* 嘉浩 */
  5: {
    background:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/abde8c0b1c41aaeab42830b6b2575e15.webp',
    btns: [
      {
        width: 293,
        height: 64,
        left: 41,
        top: 562,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F7f0a12415dcc1155dd739faa008a2b73.png'
      },
      {
        width: 293,
        height: 64,
        left: 41,
        top: 484,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F1413a301db23686ee1fdce7f52bae856.png'
      }
    ]
  },
  /* 白洁 */
  6: {
    background:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/40845aff647accc69d5cc217fa725c04.webp',
    btns: [
      {
        width: 293,
        height: 64,
        left: 41,
        top: 563,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F12117d67eb6eeaf315b9cc02ecc5aa50.png'
      },
      {
        width: 293,
        height: 64,
        left: 41,
        top: 484,
        route:
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252Fd3a3d3458e2ea20f2ef07c0602e97496.png'
      }
    ]
  }
}
export { IncomingLineData }
